import { Component, AfterViewInit, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../services/common/auth.service';
import { AppointmentRequestService } from '../../../services/appointment_requests/appointment-request.service';

@Component({
  selector: 'app-appointment-request-index',
  templateUrl: './appointment-request-index.component.html',
  styleUrls: ['./appointment-request-index.component.css'],
})
export class AppointmentRequestIndexComponent implements OnInit, AfterViewInit {
  ONEDAY: number = 86400000; // in milliseconds

  search_params: any = {
    for_index: true,
    date_range: [-1, 0],
    from_date: null,
    to_date: null,
    status: 'Pending',
    order_by: 'Created At',
    in_order_of: 'Descending',
    created_by: 'null',
    per_page: 30,
    page: 1,
    with_count: true,
  };

  search_options: any = {};

  appointment_requests: any;
  appointmentRequestCount: number;

  allowedNewAppointmentCreation: boolean = false;

  constructor(private authService: AuthService, private appointmentRequestService: AppointmentRequestService, private route: ActivatedRoute, private router: Router) {
    this.authService.fetchUserGroups().then((groups) => {
      this.allowedNewAppointmentCreation = this.authService.getUser().is('attorney superuser tech');
    });
    this.appointmentRequestService.getSearchOptions().then((search_options) => {
      this.search_options = search_options;
      this.search_params.date_range = search_options.date_ranges[0].range;
      this.dateRangeChange(this.search_params.date_range);
      this.search_params.per_page = search_options.per_page;
      this.search();
    });
  }

  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  ngOnInit() {
    if (this.route.snapshot.params['matter_id']) this.search_params.matter_id = this.route.snapshot.params['matter_id'];
  }

  ngAfterViewInit() {
    this.setInitialSidebarPosition();
  }

  newAppointmentRequest() {
    this.router.navigateByUrl('/appointment_requests/new');
  }

  pageChanged(event: any) {
    this.search_params.page = event.page;
    this.search();
  }

  search() {
    this.appointmentRequestService.search(this.search_params).then((search_result) => {
      this.appointment_requests = search_result.appointment_requests;
      this.appointmentRequestCount = search_result.count;
    });
  }

  clear_search() {
    this.search_params = {
      for_index: true,
      date_range: [-1, 0],
      from_date: null,
      to_date: null,
      status: 'Pending',
      order_by: 'Created At',
      in_order_of: 'Descending',
      created_by: 'null',
      per_page: 30,
      page: 1,
      with_count: true,
    };

    this.search_options = {};

    this.appointmentRequestService.getSearchOptions().then((search_options) => {
      this.search_options = search_options;
      this.search_params.date_range = search_options.date_ranges[0].range;
      this.dateRangeChange(this.search_params.date_range);
      this.search_params.per_page = search_options.per_page;
      this.search();
    });
  }

  dateRangeChange(value: any) {
    var date = new Date();
    this.search_params.from_date = this.format_date(new Date(Number(date) + value[0] * this.ONEDAY));
    this.search_params.to_date = this.format_date(new Date(Number(date) + value[1] * this.ONEDAY));
  }

  appointmentRequestCountLabel() {
    if (this.appointmentRequestCount == 1) return '1 appointment request';
    else return this.appointmentRequestCount + ' appointment requests';
  }

  appointmentRequestResultCountLabel(count: number): string | void {
    if (count) {
      if (count == 1) return '1 contact attempt';
      else return count + ' contact attempts';
    }
  }

  checkOutAppointmentRequest(appointment_request: any) {
    this.appointmentRequestService.updateAppointmentRequest(appointment_request.id, { check_out: true }).then((response_json) => {
      appointment_request.editing_allowed_while_checked_out = true;
      appointment_request.checked_out = true;
      appointment_request.checked_out_by_name = response_json.checked_out_by_name;
      appointment_request.checked_out_on = response_json.checked_out_on;
    });
  }

  releaseCheckOut(appointment_request: any) {
    this.appointmentRequestService.updateAppointmentRequest(appointment_request.id, { release_checkout: true }).then((response_json) => {
      appointment_request.editing_allowed_while_checked_out = false;
      appointment_request.checked_out = false;
      appointment_request.checked_out_by_name = null;
      appointment_request.checked_out_on = null;
    });
  }

  // Old v5 code for maintaining sidebar position and height - used with window scroll listener from above

  format_date(date: Date) {
    var date_str = '';
    var tmp = date.getMonth() + 1;
    date_str += (tmp > 0 ? tmp : '0' + tmp) + '/';
    tmp = date.getDate();
    date_str += (tmp > 0 ? tmp : '0' + tmp) + '/';
    date_str += date.getFullYear();
    return date_str;
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content_main');
    var content_sidebar = document.getElementById('content_sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 40;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 40;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content_sidebar');
    var content_search = document.getElementById('search_form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 81;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }

  setInitialSidebarPosition() {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
    let sidebar_position = () => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    };
    for (var i = 1; i < 20; i += 1) setTimeout(sidebar_position, (i * 1000) / 2);
  }
}
